// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__1Y_6Y","logoPri":"Logo_logoPri__225FP","logoSec":"Logo_logoSec__B9bXb","icon":"Logo_icon__3WCEE"};